import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=a66fa7a2&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./resource.vue?vue&type=style&index=1&id=a66fa7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66fa7a2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/builds/master/frontend/frontend-universe/components/avatar.vue').default,SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default,Preview: require('/builds/master/frontend/frontend-universe/components/preview.vue').default})
